import { queryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IIntegrationStatus } from 'views/DealDashboard/types';

const getCRMIntegrationStatusQueryOptions = (organizationId: string) => queryOptions({
    queryKey: ['CRMIntegrationStatus', organizationId],
    queryFn: async () => {
        const response = await axiosInstance.get<IIntegrationStatus>(
            API_ENDPOINTS.CRM.INTEGRATIONS(organizationId),
        );
        return response.data;
    },
});

export default getCRMIntegrationStatusQueryOptions;
